import {useDialogContext} from "../../dialogs/hooks/useDialogContext";
import {EditTagsDialogStateData} from "../types/EditTagsDialogStateData";

export const useEditTagsDialog = () => useDialogContext<EditTagsDialogStateData>('edit-tags');
